module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "main_layout",
    attrs: {
      "md-gutter": "",
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-column": "",
      "md-gutter": "",
      "md-align": "center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "77px",
      "width": "265px",
      "margin": "50px 0 0 0"
    },
    attrs: {
      "src": require("../assets/chemistryAI_logo.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "md-display-2",
    staticStyle: {
      "margin": "100px 0"
    }
  }, [_vm._v("RESULTS OF YOUR TEST")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticStyle: {
      "max-height": "110px"
    },
    attrs: {
      "md-align": "center"
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "#6faa43 !important"
    }
  }, [_vm._v("HUMAN MOLECULES")])]), _vm._v(" "), _c('md-layout', [_c('ul', _vm._l((_vm.filterHuman), function(human) {
    return _c('li', {
      key: human.id,
      staticClass: "results-list-item"
    }, [_c('md-card', [_c('md-card-media-cover', [_c('md-card-media', [_c('img', {
      class: {
        liked: _vm.moleculeLiked(human)
      },
      staticStyle: {
        "width": "100%",
        "height": "auto"
      },
      attrs: {
        "src": '/static/mol/' + human.name + '.png'
      }
    })]), _vm._v(" "), _c('center', [(_vm.emotive()) ? _c('div', {
      staticClass: "emotions"
    }, [_c('span', {
      staticClass: "md-title"
    }, [_vm._v("Interest: "), _c('strong', [_vm._v(" " + _vm._s(_vm.moleculeInterestValue(human)) + " % ")])]), _vm._v(" "), _c('span', {
      staticClass: "md-title"
    }, [_vm._v("Excitement: "), _c('strong', [_vm._v(" " + _vm._s(_vm.moleculeExcitementValue(human)) + " % ")])]), _vm._v(" "), _c('span', {
      staticClass: "md-title"
    }, [_vm._v("Stress: "), _c('strong', [_vm._v(_vm._s(_vm.moleculeStressValue(human)) + " % ")])])]) : _vm._e()])], 1)], 1)], 1)
  }), 0)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticStyle: {
      "max-height": "110px"
    },
    attrs: {
      "md-align": "center"
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "#58b1df !important"
    }
  }, [_vm._v("GAN MOLECULES")])]), _vm._v(" "), _c('md-layout', [_c('ul', _vm._l((_vm.filterGAN), function(gan) {
    return _c('li', {
      key: gan.id,
      staticClass: "results-list-item"
    }, [_c('md-card', [_c('md-card-media-cover', [_c('md-card-media', [_c('img', {
      class: {
        liked: _vm.moleculeLiked(gan)
      },
      staticStyle: {
        "width": "100%",
        "height": "auto"
      },
      attrs: {
        "src": '/static/mol/' + gan.name + '.png'
      }
    })]), _vm._v(" "), _c('center', [(_vm.emotive()) ? _c('div', {
      staticClass: "emotions"
    }, [_c('span', {
      staticClass: "md-title"
    }, [_vm._v("Interest: "), _c('strong', [_vm._v(" " + _vm._s(_vm.moleculeInterestValue(gan)) + " % ")])]), _vm._v(" "), _c('span', {
      staticClass: "md-title"
    }, [_vm._v("Excitement: "), _c('strong', [_vm._v(" " + _vm._s(_vm.moleculeExcitementValue(gan)) + " % ")])]), _vm._v(" "), _c('span', {
      staticClass: "md-title"
    }, [_vm._v("Stress: "), _c('strong', [_vm._v(" " + _vm._s(_vm.moleculeStressValue(gan)) + " % ")])])]) : _vm._e()])], 1)], 1)], 1)
  }), 0)])], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d0475c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExperimentResult.vue
// module id = 335
// module chunks = 1